import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faGlobe} from '@fortawesome/free-solid-svg-icons'
import { useLocation } from 'react-router-dom';
import { BASE_NAME } from "../routes";

const IndexDropdown = ({dropdownId, buttonName, linkOptions, buttonOptions, icon, changeLanguage, goHome}) => {
  
  const location = useLocation();
  const pathname = location.pathname;

  const [showMenu, setShowMenu] = useState(false);

  const scrollToSection = (alignment, sectionRef) => {
    if (sectionRef && sectionRef.current) {
      sectionRef.current.scrollIntoView(alignment);
    }
  };

  const handleButtonClick = (e, sectionRef) => {
    e.preventDefault();

    if (pathname !== BASE_NAME) {
      goHome(sectionRef)
    } else {
      scrollToSection({ behavior: 'smooth', block: 'start', inline: 'center'}, sectionRef);
    }
    setShowMenu((show) => !show);
  };
  
  return (
      <div style={{position: 'relative'}}>
        {
          icon ? 
          <button id="dropdownDefaultButton" 
          data-dropdown-toggle={dropdownId} 
          className=" text-blueGray-700 px-5 py-4 flex items-center uppercase text-xs font-bold" type="button"
          onClick={() => setShowMenu((open) => !open)}
          >
            <FontAwesomeIcon icon={faGlobe} />
            <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4"/>
            </svg>
          </button>
          :
          <button id="dropdownDefaultButton" 
            data-dropdown-toggle={dropdownId} 
            className=" text-blueGray-700 w-48 px-5 py-4 flex items-center uppercase text-xs font-bold " type="button"
            onClick={() => setShowMenu((open) => !open)}
          >
            {buttonName} 
            <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4"/>
            </svg>
          </button>

        }
        <div 
          id={dropdownId} 
          className={`${ !showMenu ? 'hidden' : ''} z-10 font-normal bg-white divide-y divide-gray-100 rounded-lg shadow w-full dark:bg-gray-700 dark:divide-gray-600`}
          style={{position: 'absolute'}}>
            <ul className="w-full p-4 text-sm text-blueGray-700" aria-labelledby="dropdownDefaultButton">
            {
                buttonOptions.length !== 0 && buttonOptions.map((option) => {
                  return (
                    <button 
                      key={option.name}
                      onClick={(event) => handleButtonClick(event, option.ref)} 
                      className={
                        "text-sm text-left hover:underline font-normal w-full pb-2 whitespace-nowrap bg-transparent text-blueGray-700"
                      }
                      >
                        {option.name}
                    </button>
                  )
                })
              }  
              {
                linkOptions.map((option) => {
                  if (icon) {
                    return (
                      <li key={option} className="text-left block text-blueGray-700 hover:underline pb-2">
                        <button onClick={() => changeLanguage(option)}>
                          {option}
                        </button>
                      </li>
                    )
                  } else {
                    return (
                      <li key={option.name} className="text-left block text-blueGray-700  hover:underline pb-2">
                        <a href={option.link}>{option.name}</a>
                      </li>
                    )
                  }
                })
              }          
            </ul>
        </div>
      </div>
  )
}

const FooterDropdown = ({dropdownId, buttonName, linkOptions, buttonOptions, goHome}) => {
  
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;
  
  const scrollToSection = (alignment, sectionRef) => {
    
    if (sectionRef && sectionRef.current) {
      sectionRef.current.scrollIntoView(alignment);
    }
  };

  const handleButtonClick = (e, sectionRef) => {
    e.preventDefault();

    if (pathname !== BASE_NAME) {
      goHome(sectionRef)
    } else {
      scrollToSection({ behavior: 'smooth', block: 'start', inline: 'center'}, sectionRef);
    }
    setShowMenu((show) => !show)
  };

  return (
    <>
      <button  
        id="dropdownDefaultButton" 
        data-dropdown-toggle={dropdownId} 
        className="text-blueGray-600 hover:text-blueGray-800 font-semibold text-sm pb-2 text-center inline-flex items-center"
        type="button"
        onClick={() => setShowMenu((show) => !show)}
      >
        {buttonName} 
        <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4"/>
        </svg>
      </button>

      <div id={dropdownId} 
        className={`${!showMenu ? 'hidden' : ''} z-10 divide-y divide-gray-100`}
        >
          <ul 
            style={{transition:'all 0.3s ease-in-out'}}
            className="text-sm text-gray-700 dark:text-gray-200 pb-2" 
            aria-labelledby="dropdownDefaultButton">
              {
                buttonOptions.map((option) => {
                  return(
                    <li key={option.name}>
                      <button 
                      className="pb-2 hover:underline"
                      onClick={(event) => handleButtonClick(event, option.ref)}>
                        {option.name}
                      </button>
                    </li>
                  )
                })
              }
              {
                linkOptions.map((option) => {                  
                  return (
                    <li key={option.name} className="pb-2">
                    <a href={option.link} className="hover:underline">
                      {option.name}
                    </a>
                    </li>
                  )                                  
                })
              }
          </ul>
      </div>
    </>
  )
}

export {FooterDropdown, IndexDropdown};